import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Capability } from '../../../models/service/capability';

@Component({
    selector: 'app-capability-card',
    templateUrl: './capability-card.component.html',
    styleUrls: ['./capability-card.component.scss'],
    standalone: false
})
export class CapabilityCardComponent implements OnInit {

  @Input() capability: any;
  @Input() showLink = true;
  @Input() selectable = false;
  @Input() isUpdated = true;
  @Input() capabilityDescription: Capability[];
  @Output() selectionChanged = new EventEmitter();

  constructor() {  }

  ngOnInit(): void {}

  toggleSelection(): void {
    this.capability.selected = !this.capability.selected;
    this.selectionChanged.emit(this.capability);
  }

  viewDetails(): void {

  }

}
